import React from "react";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import performRequest from "../../../api/request";
import CustomTextArea from "../../../CustomComponent/custom_textarea";
import { Form, Formik } from "formik";
import { CreateCelebration } from "../../../SchemaInfo/info";
import { celebrationSchema } from "../../../Schemas/celebration/celebrationSchema";
import Footer from "../../../Components/Footer/footer";
import { FcInspection } from "react-icons/fc";
import CustomInput from "../../../CustomComponent/custom_input";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const Addcelebratiion = () => {
  const navigate = useNavigate();

  const handleSubmit = (values, actions) => {
    performRequest("POST", "/celebration/createCelebrtation/", values)
      .then((res) => {
        if (res.status === 201) {
          Toast("success", "Celebration Schedule Sucessfully !");
          navigate(`/`);
        } else {
          Toast("error", "Error while creating celebration");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  };

  return (
    <>
      <div className="page">
        <div className="page-wrapper">
          <div className="container-xl">
            <div className="page-header d-print-none">
              <div className="row g-2 align-items-center">
                <div className="col">
                  <h2 className="page-title mb-1">
                    {" "}
                    <FcInspection className="fs-2 me-1" />
                    Schedule Celebration
                  </h2>
                  <h4 className="text-muted">
                    <StepRoutes />
                  </h4>
                </div>
              </div>
            </div>
            <div className="card my-4">
              <div className="ps-3 pt-3">
                <h1
                  className="text-center"
                  style={{
                    color: "rgb(131, 129, 69)",
                    fontWeight: "700",
                    fontSize: "30px",
                  }}
                >
                  SCHEDULE CELEBRATION
                </h1>
              </div>
              <hr></hr>
              <Formik
                initialValues={CreateCelebration}
                validationSchema={celebrationSchema}
                onSubmit={handleSubmit}
              >
                {(props) => (
                  <Form>
                    <div className="card-body">
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Enter Name :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="name" type="text" />
                          {props.touched.name && props.errors.name && (
                            <p className="text-danger">{props.errors.name}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Description :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="description" type="text" />
                          {props.touched.description &&
                            props.errors.description && (
                              <p className="text-danger">
                                {props.errors.description}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Select Time :
                        </label>
                        <div className="w-100 col">
                          <CustomInput name="time" type="time" />
                          {props.touched.time && props.errors.time && (
                            <p className="text-danger">{props.errors.time}</p>
                          )}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label  col-3">
                          Duration :
                        </label>
                        <div className="w-100 col">
                          <CustomInput
                            name="duration"
                            type="text"
                            placeholder="Ex. 5"
                          />
                          {props.touched.duration && props.errors.duration && (
                            <p className="text-danger">
                              {props.errors.duration}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="card-footer">
                      <div className="btn-list justify-content-end">
                        {/* <FormSubmitButton
                          buttonText="Submit Feedback"
                          className="btn btn-success"
                        /> */}
                        <button className="btn mx-1 mt-2 btn-success">
                          SUBMIT
                        </button>
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Addcelebratiion;
